var CSR = (function($) {
  function initCSRNav() {
    gsap.registerPlugin(ScrollTrigger);

    var $sections = $(".csr-section[data-section]");
    var $navItems = $(".csr-nav__item");

    if (!$sections.length || !$navItems.length) return;

    function setCurrent(sectionName) {
      $navItems.removeClass("csr-nav__item--current");
      $('.csr-nav__item[data-section="' + sectionName + '"]').addClass(
        "csr-nav__item--current"
      );
    }

    function scrollToSection(sectionName) {
      var $target = $('.csr-section[data-section="' + sectionName + '"]');

      if (!$target.length) return;

      var offset = 80;
      var top = $target.offset().top - offset;

      $("html, body").animate(
        {
          scrollTop: top
        },
        800
      );
    }

    $sections.each(function() {
      var section = this;
      var sectionName = $(section).data("section");

      ScrollTrigger.create({
        trigger: section,
        start: "top 50%",
        end: "bottom 50%",
        onEnter: function() {
          setCurrent(sectionName);
        },
        onEnterBack: function() {
          setCurrent(sectionName);
        }
      });
    });

    $(".csr-nav__link").on("click", function(e) {
      e.preventDefault();

      var $item = $(this).closest(".csr-nav__item");
      var sectionName = $item.data("section");

      if (!sectionName) return;

      setCurrent(sectionName);
      scrollToSection(sectionName);
    });

    $(".csr-nav__link.link--cross").on("click", function(e) {
      e.preventDefault();
      e.stopPropagation();

      $(this).toggleClass("link--minus");
      $(".csr-subnav__list").slideToggle();
    });
  }

  function init() {
    if (!$(".page-template-template-csr").length) return;

    initCSRNav();
  }

  return {
    init: init
  };
})(jQuery);

jQuery(document).ready(CSR.init);
